<template lang="html"> 
    <section class="wizard">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Add New Menu</h4>
                        <vue-good-wizard :steps="steps" 
                                         :onNext="nextClicked" 
                                         :onBack="backClicked">
                            <div slot="page1">
                                <menu-add-basic-info :menu="menu"/>
                            </div>
                            <div slot="page2">
                                <menu-add-items-list :menu="menu"/>
                            </div>
                            <div slot="page3">
                                Press Save to create a new menu
                            </div>
                        </vue-good-wizard>
                    </div>
                </div>
            </div>
        </div> 
  </section>
</template> 

<script lang="js">
import { mapActions, mapState } from'vuex'
import { GoodWizard } from 'vue-good-wizard'
import MenuBaseForm from '../Bases/MenuBaseForm'
import MenuAddBasicInfo from './MenuAddBasicInfo'
import MenuAddItemsList from './MenuAddItemsList'
export default{
  name: 'menuaddfrom',
  extends: MenuBaseForm,
  components: {
     MenuAddBasicInfo,
     MenuAddItemsList,
     'vue-good-wizard': GoodWizard
  },
  methods: {
      
  },
  created () {
      this.setAction('menus/createMenuAction');
  }
 
}
</script>